export default __webpack_public_path__ + "static/media/kiddy.58a8c952.png";